import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import StatsRadialMeter from "../../reusable/RadialMeter/StatsRadialMeter";
import Section from "../../reusable/Layout/Section";
import Page from "../../reusable/Layout/Page";
import PercentageBarsWrapper from "../../reusable/PercentageBars/PercentageBarsWrapper";
import PercentageBar from "../../reusable/PercentageBars/PercentageBar";
import reduxStore from './../../../scripts/reduxStore';
import { withRouter } from 'react-router';
import accountUsageApi from './../../api/AccountUsage.api';
import utils from '../../utils/utilities';
import xhr from '../../utils/xhr';
import headerActions from '../../reusable/Header/Header.actions';
import EntitiesAuditDownloadModalWrapper from './Components/EntitiesAuditDownloadModalWrapper';
import UserAuditDownloadModalWrapper from './Components/UserAuditDownloadModalWrapper';
import {AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE} from './../../constants';

class AccountUsage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            subscription:     null,
            usersActive:      null,
            usersInactive:    null,
            entitiesActive:   null,
            entitiesInactive: null,
            alertsActive:     null,
            alertsInactive:   null,
            activeModal: null
        };

        this.getEntitiesData = this.getEntitiesData.bind(this);
        // this.getAlertsData = this.getAlertsData.bind(this);
        this.handleEntitiesAuditModal = this.handleEntitiesAuditModal.bind(this);
        this.handleUserAuditModal = this.handleUserAuditModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.appSettings = reduxStore.getState().user.appSettings;
    }

    componentDidMount() {
        if (!this.appSettings.accountPageEnabled) {
            this.props.router.push("/start");
        }

        headerActions.updateHeader('adminPage');
        this.getUsersData();
        this.getEntitiesData();
        // this.getAlertsData();
    }

    getUsersData() {
        accountUsageApi.getUsersData()
            .then((response) => {
                this.setState({
                    usersActive:   response.body.activeUsers,
                    usersInactive: response.body.inactiveUsers
                });
            })
            .catch((error) => {
                utils.logError(error, 'accountUsageApi.getUsersData():');
                xhr.handleAllErrors(error);
            });
    }

    getEntitiesData() {
        accountUsageApi.getEntitiesData()
            .then((responses) => {
                this.setState({
                    entitiesActive:   responses.entitiesActive,
                    entitiesInactive: responses.entitiesInactive,
                    subscription:     responses.subscription
                });
            })
            .catch((error) => {
                utils.logError(error, 'accountUsageApi.getAllData():');
                xhr.handleAllErrors(error);
            });
    }

    // getAlertsData() {
    //     accountUsageApi.getAlertsData()
    //         .then((responses) => {
    //             this.setState({
    //                 alertsActive:   responses.alertsActive,
    //                 alertsInactive: responses.alertsInactive
    //             });
    //         })
    //         .catch((error) => {
    //             utils.logError(error, 'accountUsageApi.getAlertsData():');
    //             xhr.handleAllErrors(error);
    //         });
    // }


    closeModal() {
        this.setState({ activeModal: null });
    }

    showEntitiesAuditModal(props) {
        this.setState({ activeModal: <EntitiesAuditDownloadModalWrapper {...props} /> });
    }

    handleEntitiesAuditModal() {
        let modalProps = {
            primaryAction:   this.downloadEntitiesAudit,
            secondaryAction: this.closeModal
        };
        this.showEntitiesAuditModal(modalProps);
    }

    showUserAuditModal(props) {
        this.setState({ activeModal: <UserAuditDownloadModalWrapper {...props} /> });
    }

    handleUserAuditModal() {
        let modalProps = {
            primaryAction: this.downloadUserAudit,
            secondaryAction: this.closeModal
        };
        this.showUserAuditModal(modalProps);
    }

    render() {

        let planUsageUsed = null;
        let planUsageRemaining = null;
        if (this.state.entitiesActive >= 0 && this.state.entitiesInactive >= 0 && this.state.subscription >= 0) {
            planUsageUsed = Math.floor(((this.state.entitiesActive + this.state.entitiesInactive) / this.state.subscription) * 100);
            planUsageRemaining = 100 - planUsageUsed;
        }

        const usersValues = [
            {label: "Active", value: this.state.usersActive === null ? 0 : this.state.usersActive},
            {label: "Deactivated", value: this.state.usersInactive === null ? 0 : this.state.usersInactive},
        ];

        const entitiesValues = [
            {label: "Active", value: this.state.entitiesActive === null ? 0 : this.state.entitiesActive},
            {label: "Deactivated", value: this.state.entitiesInactive=== null ? 0 : this.state.entitiesInactive},
        ];

        const alertsValues = [
            {label: "Active", value: this.state.alertsActive === null ? 0 : this.state.alertsActive},
            {label: "Deactivated", value: this.state.alertsInactive === null ? 0 : this.state.alertsInactive},
        ];

        return (
            <Page className="account-usage-page listing-page">

                <Section title={<FormattedMessage id='UserAudit_Download_UIText_usageStatistics'/>} className='plan-usage'>
                    <PercentageBarsWrapper isLoading={!planUsageUsed && !planUsageRemaining} >
                        <PercentageBar index={0}
                                       barPercentage={planUsageUsed}
                                       barMessage={planUsageUsed >= AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE && <div>{planUsageUsed}% <span className="smaller"><FormattedMessage id='General_CoreFunctionality_UIText_general.used'/></span></div>}
                                       tooltipMessage={planUsageUsed >= AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE && this.props.intl.formatMessage({id: 'UserAudit_Download_UIText_numberOfAddedEntities'}, { value: this.state.entitiesActive + this.state.entitiesInactive })} />

                        <PercentageBar index={1}
                                       barPercentage={planUsageRemaining}
                                       barMessage={planUsageRemaining >= AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE && <div>{planUsageRemaining}% <span className="smaller"><FormattedMessage id='General_CoreFunctionality_UIText_general.available'/></span></div>}
                                       tooltipMessage={planUsageRemaining >= AUDIT_REPORTS_PROGRESS_BAR_TOOLTIP_PERCENTAGE && this.props.intl.formatMessage({id: 'UserAudit_Download_UIText_numberOfAvailableEntities'}, { value: this.state.subscription - this.state.entitiesActive - this.state.entitiesInactive })} />
                    </PercentageBarsWrapper>
                </Section>

                <Section title={<FormattedMessage id='UserAudit_Download_UIText_entityUsage'/>} className='individual-usage'>
                    <div className="stats-columns">

                        <div className="stats-column">
                            <div className="stats-column_title">
                                <FormattedMessage id='General_CoreFunctionality_UIText_general.users' />
                                {
                                    this.appSettings.isAuditUsersDownloadEnabled &&
                                    <span className='la-Download'
                                          title={this.props.intl.formatMessage({id: 'UserAudit_Download_UIText_modalTitle'})}
                                          onClick={this.handleUserAuditModal} />
                                }

                            </div>
                            <StatsRadialMeter isLoading={this.state.usersActive === null && this.state.usersInactive === null}
                                              value={this.state.usersActive === null ? 0 : this.state.usersActive}
                                              totalValue={
                                                  (this.state.usersActive === null && this.state.usersInactive === null) ?
                                                   0 : this.state.usersActive + this.state.usersInactive
                                              }
                                              subValues={usersValues} />
                        </div>

                        <div className="stats-column">
                            <div className="stats-column_title">
                                <FormattedMessage id='HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies' />
                                {
                                    this.appSettings.isAuditEntitiesDownloadEnabled &&
                                    <span className='la-Download'
                                          title={this.props.intl.formatMessage({id: 'UserAudit_Download_UIText_entitiesTooltip'})}
                                          onClick={this.handleEntitiesAuditModal} />
                                }
                            </div>
                            <StatsRadialMeter isLoading={this.state.entitiesActive === null && this.state.entitiesInactive === null}
                                              value={this.state.entitiesActive === null ? 0 : this.state.entitiesActive}
                                              totalValue={
                                                  (this.state.entitiesActive === null && this.state.entitiesInactive === null) ?
                                                      0 : this.state.entitiesActive + this.state.entitiesInactive
                                              }
                                              subValues={entitiesValues} />
                        </div>

                        {/*<div className="stats-column">*/}
                            {/*<div className="stats-column_title">*/}
                                {/*<FormattedMessage id='HeaderFooterNav_CoreFunctionality_Dropdown_nav.alerts' />*/}
                            {/*</div>*/}
                            {/*<StatsRadialMeter isLoading={!this.state.alertsActive && !this.state.alertsInactive}*/}
                                              {/*value={this.state.alertsActive ? this.state.alertsActive : 0}*/}
                                              {/*totalValue={(this.state.alertsActive >= 0 && this.state.alertsInactive >= 0) ?*/}
                                                  {/*this.state.alertsActive + this.state.alertsInactive : 0}*/}
                                              {/*subValues={alertsValues} />*/}
                        {/*</div>*/}

                    </div>
                </Section>
                {this.state.activeModal}

            </Page>
        )
    }
}

export default withRouter(injectIntl(AccountUsage));


// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/AccountUsage.jsx